import { mapActions, mapMutations, mapState } from 'vuex';

import funcoes from "../../../util/funcoes.js";
import { BANCOS, STATUS_CONTRATO_ALUGUEL, STATUS_RECIBO_REPASSE, FORMA_PAGAMENTO, TIPO_BOLETO_REMESSA } from "../../../util/constantes";

import AppSelecionarContaBancariaDialog from '../../../shared/dialogs/SelecionarContaBancariaDialog.vue';
import AppSelecionarAluguelDialog from '../../../shared/dialogs/SelecionarAluguelDialog.vue';

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faSortAlphaDown, faSortNumericDown, faSortNumericUp, faStopCircle } from '@fortawesome/free-solid-svg-icons';

library.add(faSortAlphaDown, faSortNumericDown, faSortNumericUp, faStopCircle)

export default {
  components: {
    AppSelecionarContaBancariaDialog,
    AppSelecionarAluguelDialog,
    FontAwesomeIcon
  },
  data() {
    return {
      remessa: {
        dataInicio: funcoes.primeiroDiaMes(),
        dataFim: funcoes.ultimoDiaMes(),
        tipoData: 'DATA_VENCIMENTO',
        tipoBoletoRemessa: 'TODOS'
      },

      contaBancaria: { nome: undefined },
      aluguel: { id: 0, idNaImobiliaria: '' },
      cliente: { id: 0, nome: '' },

      visibilidadeSelecionarContaBancariaDialog: false,
      visibilidadeSelecionarAluguelDialog: false,

      validacao: {
        dataInicio: [{ required: true, len: 10 }],
        dataFim: [{ required: true, len: 10 }]
      },
      loadingAluguel: false,
      loadingCliente: false,

      tabSelecionada: 'cobrancas',
      stateFilterButtonBoletos: {
        labelFilterButton: 'Sem Ordenação',
        iconFilterButton: 'stop-circle',
        color: '#DF1B1B'
      },

      filtragemAtualBoletos: 'SEM_ORDENACAO',

      stateFilterButtonRepasses: {
        labelFilterButton: 'Sem Ordenação',
        iconFilterButton: 'stop-circle',
        color: '#DF1B1B'
      },

      filtragemAtualRepasses: 'SEM_ORDENACAO',

      //PAGINAÇÃO
      currentPageBoletos: 1,
      currentPageRepasses: 1,
      maxItens: 100,
    }
  },
  computed: {
    ...mapState('remessasStore', {
      boletos(state) { return state.boletos },
      repasses(state) { return state.repasses },
      boletosFiltrados(state) { return state.boletos.slice(this.paginaAtualBoletosParaIndice * this.maxItens, this.currentPageBoletos * this.maxItens) },
      repassesFiltrados(state) { return state.repasses.slice(this.paginaAtualRepassesParaIndice * this.maxItens, this.currentPageRepasses * this.maxItens) },
      quantidadeTotalBoletos(state) { return state.boletos.length },
      quantidadeTotalRepasses(state) { return state.repasses.length },
      alugueis(state) { return state.alugueis },
      clientes(state) { return state.clientes },
      tabSelecionadaState(state) { return state.tabSelecionada },
      quantidadeBoletosSelecionados(state) { return state.boletos.filter(item => { return item.selecionado }).length },
      quantidadeRepassesSelecionados(state) { return state.repasses.filter(item => { return item.selecionado }).length },
    }),
    //PAGINAÇÃO
    paginaAtualBoletosParaIndice() {
      return this.currentPageBoletos - 1;
    },
    paginaAtualRepassesParaIndice() {
      return this.currentPageRepasses - 1;
    },

    formasPagamento() {
      return FORMA_PAGAMENTO
    },
    bancos() {
      return BANCOS
    },
    tiposBoletosRemessa() {
      return TIPO_BOLETO_REMESSA;
    },
    labelQuantidadeCobrancas() {
      switch (this.quantidadeTotalBoletos) {
        case 1:
          return `${this.quantidadeTotalBoletos} Boleto encontrado`
        case 0:
          return '';
        default:
          return `Exibindo ${this.paginaAtualBoletosParaIndice * this.maxItens + 1} a ${this.boletosFiltrados.length + this.paginaAtualBoletosParaIndice * this.maxItens} de ${this.quantidadeTotalBoletos} Boletos`
      }
    },
    labelQuantidadeRepasses() {
      switch (this.repasses.length) {
        case 1:
          return `${this.repasses.length} Repasse encontrado`
        case 0:
          return ''
        default:
          return `Exibindo ${this.paginaAtualRepassesParaIndice * this.maxItens + 1} a ${this.repassesFiltrados.length + this.paginaAtualRepassesParaIndice * this.maxItens} de ${this.quantidadeTotalRepasses} Repasses`
      }
    },
    labelCobrancasSelecionadas() {
      switch (this.quantidadeBoletosSelecionados) {
        case 1:
          return `${this.quantidadeBoletosSelecionados} Boleto selecionado`
        case 0:
          return '';
        default:
          return ` ${this.quantidadeBoletosSelecionados} Boletos selecionados`
      }
    },
    labelRepassesSelecionados() {
      switch (this.quantidadeRepassesSelecionados) {
        case 1:
          return `${this.quantidadeRepassesSelecionados} Repassse selecionado`
        case 0:
          return '';
        default:
          return `${this.quantidadeRepassesSelecionados} Repasses selecionados`
      }
    },
    exibirLabelSelecionados() {
      return (this.quantidadeBoletosSelecionados > 0 && this.tabSelecionada === 'cobrancas') ||
        (this.quantidadeRepassesSelecionados > 0 && this.tabSelecionada === 'pagamentos');
    },
    labelSelecionados() {
      return this.tabSelecionada === 'cobrancas' ? this.labelCobrancasSelecionadas : this.labelRepassesSelecionados;
    }
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('remessasStore', [
      'listarBoletos',
      'gerarRemessa',
      'recuperarNumeroRemessa',
      'selecionarTodos',
      'deselecionarTodos',
      'selecionarTodosRepasses',
      'deselecionarTodosRepasses',
      'listarAlugueis',
      'listarRepasses',
      'listarClientes'
    ]),
    ...mapMutations('remessasStore', [
      'atualizarTabSelecionada',
      'limparBoletos',
      'limparRepasses'
    ]),
    selecionarTodosHandler() {
      switch (this.tabSelecionada) {
        case 'cobrancas':
          this.selecionarTodos();
          break;
        case 'pagamentos':
          this.selecionarTodosRepasses()
          break;
      }
    },
    deselecionarTodosHandler() {
      switch (this.tabSelecionada) {
        case 'cobrancas':
          this.deselecionarTodos();
          break;
        case 'pagamentos':
          this.deselecionarTodosRepasses();
          break;
      }
    },
    listarBoletosHandler() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.showLoading()
          if (this.contaBancaria.id) { this.remessa.idContaBancaria = this.contaBancaria.id }
          if (this.aluguel.id > 0) { this.remessa.idAluguel = this.aluguel.id }
          if (this.cliente.id > 0) { this.remessa.idCliente = this.cliente.id }

          this.listarBoletos(this.remessa)
            .then(() => {
              this.hideLoading()
              this.limparCampos();
            })
            .catch(() => {
              this.hideLoading()
              this.limparCampos();
              this.$message.error("Não foi possível conectar-se ao servidor");
            });
        }
      });
    },
    listarRemessasHandler() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.showLoading();

          if (this.contaBancaria.id) { this.remessa.idContaBancaria = this.contaBancaria.id }
          if (this.aluguel.id > 0) { this.remessa.idAluguel = this.aluguel.id }
          if (this.cliente.id > 0) { this.remessa.idCliente = this.cliente.id }
        }
        this.listarRepasses(this.remessa)
          .then(() => {
            this.hideLoading();
            this.limparCampos();
          })
          .catch(() => {
            this.hideLoading();
            this.limparCampos();
            this.$message.error("Não foi possível conectar-se ao servidor");
          });
      })
    },
    pesquisar() {
      switch (this.tabSelecionada) {
        case 'cobrancas':
          this.listarBoletosHandler();
          break;
        case 'pagamentos':
          this.listarRemessasHandler();
          break;
      }

      this.limparOrdenacao()
    },
    recuperarNumeroRemessaHandler() {
      let selecionados = this.boletos.filter(item => { return item.selecionado }).length
      let repassesSelecionados = this.repasses.filter(item => { return item.selecionado }).length
      if (selecionados === 0 && repassesSelecionados === 0) {
        this.$message.warning("Nenhum Recibo selecionado!");
        return
      }

      this.showLoading()

      let payload = { id: this.contaBancaria.id }

      this.recuperarNumeroRemessa(payload)
        .then(resultado => {
          this.hideLoading()

          switch (resultado.status) {
            case 'SUCESSO':
              this.$confirm("Deseja gerar a remessa Nº " + resultado.item + "?", "Atenção", {
                confirmButtonText: "Sim",
                cancelButtonText: "Não",
                type: "warning"
              }).then(() => {
                this.gerarRemessaHandler(resultado.item)
              });
              break;
            default:
              this.$message.warning("Não foi possível recuperar o número da remessa");
              break;
          }
        })
        .catch(() => {
          this.hideLoading()
          this.$message.error("Não foi possível conectar-se ao servidor");
        });
    },

    async gerarRemessaHandler(numeracaoRemessa) {
      this.showLoading()

      let payload = {}
      let boletosAvulsos = []
      let recibos = []

      if (this.tabSelecionada === 'cobrancas') {
        boletosAvulsos = this.boletos.filter(item => { return !item.mesSerie })
        boletosAvulsos = boletosAvulsos.filter(item => { return item.selecionado })
        boletosAvulsos = boletosAvulsos.map(item => { return item.id })

        recibos = this.boletos.filter(item => { return item.mesSerie })
        recibos = recibos.filter(item => { return item.selecionado })
        recibos = recibos.map(item => { return item.id })
      } else if (this.tabSelecionada === 'pagamentos') {
        recibos = this.repasses.filter(item => { return item.mesSerie })
        recibos = recibos.filter(item => { return item.selecionado })
        recibos = recibos.map(item => { return item.id })
      }

      try {
        let numeracaoRemessaIncrement = parseInt(numeracaoRemessa);

        while(boletosAvulsos.length > 0 || recibos.length > 0) {
          const recibosCutted = recibos.splice(0, 200);

          payload = {
            recibos: recibosCutted,
            boletosAvulsos: boletosAvulsos.splice(0, 200 - recibosCutted.length),
            idContaBancaria: this.contaBancaria.id,
            idAluguel: this.aluguel.id,
            numeracaoRemessa: numeracaoRemessaIncrement + ""
          }

          const resultado = await this.gerarRemessa(payload);

          const url = window.URL.createObjectURL(new Blob([resultado.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', this.contaBancaria.banco === 'SICRED' ? this.gerarNomeArquivoRemessaSicredi() : this.contaBancaria.banco === 'INTER' ? this.gerarNomeArquivoInter(numeracaoRemessaIncrement) :
          numeracaoRemessaIncrement + '.rem');
          document.body.appendChild(link)
          link.click();

          numeracaoRemessaIncrement += 1;
        }

        this.limparCampos();
      } catch(error) {
        this.$message.error("Não foi possível conectar-se ao servidor");
      } finally {
        this.reset();
        this.hideLoading();
      }
    },

    filtrarAlugueisSelect(queryString) {
      let payload = {
        idNaImobiliaria: queryString
      }

      this.loadingAluguel = true;
      this.listarAlugueis(payload)
        .then(() => {
          this.loadingAluguel = false;
        }).catch(() => {
          this.loadingAluguel = false;
        })
    },

    filtrarClientesSelect(queryString) {
      let payload = {
        nome: queryString
      }

      this.loadingCliente = true;
      this.listarClientes(payload)
        .then(() => {
          this.loadingCliente = false;
        }).catch(() => {
          this.loadingCliente = false;
        })
    },

    // DIALOGS
    exibirSelecionarContaBancariaDialog() {
      this.visibilidadeSelecionarContaBancariaDialog = true
    },
    fecharSelecionarContaBancariaDialog(contaBancaria) {
      this.contaBancaria = contaBancaria
      this.visibilidadeSelecionarContaBancariaDialog = false;
    },
    exibirSelecionarAluguelDialog() {
      this.visibilidadeSelecionarAluguelDialog = true
    },
    fecharSelecionarAluguelDialog(aluguel) {
      this.aluguel = aluguel ? aluguel : { id: 0, idNaImobiliaria: '' }
      this.visibilidadeSelecionarAluguelDialog = false;
    },

    // UTIL
    getLabelFormaPagamento(item) {
      return funcoes.getLabel(this.formasPagamento, item.formaPagamento)
    },
    getLabelStatus(item) {
      return funcoes.getLabel(STATUS_RECIBO_REPASSE, item.status)
    },
    getLabelStatusAluguel(item) {
      return funcoes.getLabel(STATUS_CONTRATO_ALUGUEL, item.aluguel.status)
    },
    formatarPeriodo(item) {
      return item.inicioPeriodo ? item.inicioPeriodo + ' - ' + item.fimPeriodo : ''
    },
    formatarValor(item) {
      return funcoes.formatarValor(item.valor)
    },
    formatarValorPago(item) {
      return funcoes.formatarValor(item.valorPago)
    },
    limparAluguel() {
      this.aluguel = { id: 0, idNaImobiliaria: '' }
      this.remessa.idAluguel = undefined;
    },
    limparCliente() {
      this.cliente = {
        id: 0,
        nome: ''
      }
      this.remessa.idCliente = undefined;
    },
    limparCampos() {
      this.remessa = {
        ...this.remessa,
      }
    },

    storeLocalStorage(day, sequencial) {
      localStorage.setItem("dia", day);
      localStorage.setItem("sequencial", sequencial);
    },

    getDiaDaRemessa() {
      let diaDaRemessa = localStorage.getItem("dia");
      return diaDaRemessa
    },

    getSequencialDaRemessa() {
      let senquencialDaRemessa = localStorage.getItem("sequencial")
      return senquencialDaRemessa;
    },

    gerarNomeArquivoRemessaSicredi() {
      let sequencialDaRemessa = this.getSequencialDaRemessa();
      let diaDaRemessa = this.getDiaDaRemessa();

      let nomeArquivo = "";

      const today = new Date();

      const month = today.getMonth() + 1;

      const day = today.getDate();

      if (parseInt(diaDaRemessa) !== day) {
        this.storeLocalStorage(day, 0);
        sequencialDaRemessa = this.getSequencialDaRemessa();
        diaDaRemessa = this.getDiaDaRemessa();
      }

      if (parseInt(diaDaRemessa) === day) {
        let sequencialDaRemessaInt = parseInt(sequencialDaRemessa);
        this.storeLocalStorage(day, sequencialDaRemessaInt += 1);
        sequencialDaRemessa = this.getSequencialDaRemessa();
        diaDaRemessa = this.getDiaDaRemessa();
      }

      let sequencialDaRemessaInt = parseInt(sequencialDaRemessa);

      nomeArquivo += this.contaBancaria.agencia + `${month === 10 ? 'O' : month === 11 ? 'N' : month === 12 ? 'D' : month}` + (day < 10 ? '0' + day : day) + `${parseInt(sequencialDaRemessa) === 1 ? '.CRM' : `${parseInt(sequencialDaRemessa) < 10 ? '.00' + (sequencialDaRemessaInt - 1) : '.0' + (sequencialDaRemessaInt - 1)}`
        }`;

      return nomeArquivo;
    },

    gerarNomeArquivoInter(numeroRemessa) {
      let nomeArquivo = `${this.tabSelecionada == 'cobrancas' ? 'CI400' : 'CI240'}_001_${funcoes.addZerosAEsquerda(numeroRemessa, 6)}.REM`
      return nomeArquivo;
    },

    formatarIconStatus(item) {
      switch (item) {
        case 'EM_ABERTO':
          return '#4B6EF6';
        case 'PAGO':
          return '#2DB748';
      }
    },

    tabClicked(tab) {
      this.atualizarTabSelecionada(tab.name)
    },

    atualizarEstadoBotaoFiltroBoletos() {
      switch (this.filtragemAtualBoletos) {
        case 'SEM_ORDENACAO':
          this.stateFilterButtonBoletos = {
            labelFilterButton: 'Sem Ordenação',
            iconFilterButton: 'stop-circle',
            color: '#DF1B1B'
          }
          break;
        case 'ALFABETICA':
          this.stateFilterButtonBoletos = {
            labelFilterButton: 'Ordem Alfabética',
            iconFilterButton: 'sort-alpha-down',
            color: '#4B6EF6'
          }
          break;
        case 'NUMERO_RECIBO':
          this.stateFilterButtonBoletos = {
            labelFilterButton: 'Número recibo',
            iconFilterButton: 'sort-numeric-down',
            color: '#4B6EF6'
          }
          break;
        case 'MES_SERIE':
          this.stateFilterButtonBoletos = {
            labelFilterButton: 'Mes Série',
            iconFilterButton: 'sort-numeric-down',
            color: '#4B6EF6'
          }
          break;
        default:
          break;
      }
    },

    atualizarEstadoBotaoFiltroRepasses() {
      switch (this.filtragemAtualRepasses) {
        case 'SEM_ORDENACAO':
          this.stateFilterButtonRepasses = {
            labelFilterButton: 'Sem Ordenação',
            iconFilterButton: 'stop-circle',
            color: '#DF1B1B'
          }
          break;
        case 'ALFABETICA':
          this.stateFilterButtonRepasses = {
            labelFilterButton: 'Ordem Alfabética',
            iconFilterButton: 'sort-alpha-down',
            color: '#4B6EF6'
          }
          break;
        case 'NUMERO_RECIBO':
          this.stateFilterButtonRepasses = {
            labelFilterButton: 'Número recibo',
            iconFilterButton: 'sort-numeric-down',
            color: '#4B6EF6'
          }
          break;
        case 'MES_SERIE':
          this.stateFilterButtonRepasses = {
            labelFilterButton: 'Mes Série',
            iconFilterButton: 'sort-numeric-down',
            color: '#4B6EF6'
          }
          break;
        default:
          break;
      }
    },

    filtrarListaBoletos() {
      switch (this.filtragemAtualBoletos) {
        case 'SEM_ORDENACAO':
          this.filtragemAtualBoletos = 'ALFABETICA';
          this.atualizarEstadoBotaoFiltroBoletos();

          this.boletos.sort((itemA, itemB) => {
            if (itemA.cliente.nome < itemB.cliente.nome) {
              return -1;
            } else {
              true;
            }
          });

          break;
        case 'ALFABETICA':
          this.filtragemAtualBoletos = 'NUMERO_RECIBO';
          this.atualizarEstadoBotaoFiltroBoletos();

          this.boletos.sort((itemA, itemB) => {
            if (itemA.numero < itemB.numero) {
              return -1;
            } else {
              true;
            }
          });
          break;
        case 'NUMERO_RECIBO':
          this.filtragemAtualBoletos = 'MES_SERIE';
          this.atualizarEstadoBotaoFiltroBoletos();

          this.boletos.sort((itemA, itemB) => {
            if (itemA.mesSerie < itemB.mesSerie) {
              return -1;
            } else {
              true;
            }
          });
          break;
        case 'MES_SERIE':
          this.filtragemAtualBoletos = 'SEM_ORDENACAO';
          this.atualizarEstadoBotaoFiltroBoletos();

          this.boletos.sort((itemA, itemB) => {
            return funcoes.stringParaData(itemA.dataVencimento).getTime() - funcoes.stringParaData(itemB.dataVencimento).getTime()
          });
          break;
        default:
          break;
      }
    },

    filtrarListaRepasses() {
      switch (this.filtragemAtualRepasses) {
        case 'SEM_ORDENACAO':
          this.filtragemAtualRepasses = 'ALFABETICA';
          this.atualizarEstadoBotaoFiltroRepasses();

          this.repasses.sort((itemA, itemB) => {
            if (itemA.cliente.nome < itemB.cliente.nome) {
              return -1;
            } else {
              true;
            }
          });

          break;
        case 'ALFABETICA':
          this.filtragemAtualRepasses = 'NUMERO_RECIBO';
          this.atualizarEstadoBotaoFiltroRepasses();

          this.repasses.sort((itemA, itemB) => {
            if (itemA.numero < itemB.numero) {
              return -1;
            } else {
              true;
            }
          });
          break;
        case 'NUMERO_RECIBO':
          this.filtragemAtualRepasses = 'MES_SERIE';
          this.atualizarEstadoBotaoFiltroRepasses();

          this.repasses.sort((itemA, itemB) => {
            if (itemA.mesSerie < itemB.mesSerie) {
              return -1;
            } else {
              true;
            }
          });
          break;
        case 'MES_SERIE':
          this.filtragemAtualRepasses = 'SEM_ORDENACAO';
          this.atualizarEstadoBotaoFiltroRepasses();

          this.repasses.sort((itemA, itemB) => {
            return funcoes.stringParaData(itemA.dataVencimento).getTime() - funcoes.stringParaData(itemB.dataVencimento).getTime()
          });
          break;
        default:
          break;
      }
    },

    limparOrdenacao() {
      switch (this.tabSelecionada) {
        case 'cobrancas':
          this.stateFilterButtonBoletos = {
            labelFilterButton: 'Sem Ordenação',
            iconFilterButton: 'stop-circle',
            color: '#DF1B1B'
          },

            this.filtragemAtualBoletos = 'SEM_ORDENACAO';
          break;
        case 'pagamentos':
          this.stateFilterButtonRepasses = {
            labelFilterButton: 'Sem Ordenação',
            iconFilterButton: 'stop-circle',
            color: '#DF1B1B'
          },

            this.filtragemAtualRepasses = 'SEM_ORDENACAO'
          break;
      }
    },

    reset() {
      this.remessa = {
        dataInicio: funcoes.primeiroDiaMes(),
        dataFim: funcoes.ultimoDiaMes(),
        tipoData: 'DATA_VENCIMENTO',
        tipoBoletoRemessa: 'TODOS'
      }

      this.contaBancaria = { nome: undefined }
      this.aluguel = { id: 0, idNaImobiliaria: '' }
      this.cliente = { id: 0, nome: '' }
      this.limparBoletos();
      this.limparRepasses();
    }
  }
}